import { useCallback } from 'react';

import { Address } from 'viem';

import { useSignRedeem } from '@services/api/bonds/bonds.api';
import { useCreateRedeem } from '@services/contract/bonds/nftRedemption.contract';

import { useAuth } from '@contexts/common/AuthorizationContext';

import { useSignMessage } from '@hooks/common/useSignMessage';

const useCreateRedeemNft = (handleUpdate: () => Promise<void>) => {
  const { account } = useAuth();

  const { signData, isPending: isPendingSignMessage } = useSignMessage();
  const { mutateAsync: signRedeem, isPending: isPendingSignRedeem } =
    useSignRedeem();
  const { writeContractAsync, isPending: isPendingRedeem } =
    useCreateRedeem(handleUpdate);

  const redeem = useCallback(
    async (nftsAmount: number) => {
      try {
        if (!account) return;

        const timestamp = Date.now();

        const data = {
          account: account.toLowerCase() as Address,
          nftsAmount,
          timestamp,
        };

        const signature = await signData(data);

        if (!signature) return;

        const signMessage = await signRedeem({
          signature,
          data,
        });

        if (!signMessage) return;

        const redeemData = {
          uuid: BigInt(signMessage.params.uuid),
          nonce: BigInt(signMessage.params.nonce),
          seller: signMessage.params.seller as Address,
          amountNfts: BigInt(signMessage.params.amountNfts),
          totalSellPrice: BigInt(signMessage.params.totalSellPrice),
          deadline: BigInt(signMessage.params.deadline),
          signature: signMessage.signature as Address,
        };

        await writeContractAsync(redeemData);
      } catch (e) {
        console.error('useRedeemNft', e);
      }
    },
    [account],
  );

  return {
    redeem,
    isPending: isPendingSignMessage || isPendingSignRedeem || isPendingRedeem,
  };
};

export default useCreateRedeemNft;
